import AppImage from "components/AppImage";

import styles from "./LandingPageHeroSection.module.scss";

interface LandingPageHeroSectionProps {
  image?: string;
  children: React.ReactNode;
}

const LandingPageHeroSection = ({
  image,
  children,
}: LandingPageHeroSectionProps) => {
  return (
    <div className={styles.container}>
      {image && (
        <AppImage
          alt=""
          fill={true}
          isLCP={true}
          src={image}
          className={styles.background}
        />
      )}

      <div className={styles.gradient} />

      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default LandingPageHeroSection;
